import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import * as React from 'react';
import './table-styles.scss';

interface IColumn {
	name: string;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	cellRenderer?: (data: any) => any;
	label: string;
	hideHeader: boolean;
	hasSort?: boolean;
	width?: number;
	maxWidth?: number;
}

interface ITableHeader {
	columns: IColumn[];
}

export const TableHeader: React.FC<ITableHeader> = ({ columns }) => (
	<TableHead>
		<TableRow>
			{columns.map(({ name, label, hideHeader, hasSort, width, maxWidth }) => {
				return (
					<TableCell key={name} className="table-cell table-cell--header">
						{!hideHeader && (label || name)}
					</TableCell>
				);
			})}
		</TableRow>
	</TableHead>
);
